import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";
import {SpecialDay} from "../../../_models/special_day";

@Injectable({
  providedIn: 'root'
})
export class SpecialDayService {
  specialDaysUrl = environment.apiUrl + '/special_days';

  constructor(private http: HttpClient) {}

  getSpecialDays(): Observable<SpecialDay[]> {
    return this.http
      .get<SpecialDay[]>(this.specialDaysUrl);
  }

  deleteSpecialDay(id: number) {
    return this.http
      .delete(this.specialDaysUrl + `/${id}`);
  }

  addOrEdit(specialDay: SpecialDay) {
    if (typeof specialDay.specialDate.setHours === 'function') {
      specialDay.specialDate = new Date(specialDay.specialDate.setHours(12));
    } else {
      specialDay.specialDate = new Date(specialDay.specialDate)
      specialDay.specialDate.setHours(12);
    }
    const sendValue = {
      ...specialDay,
      timeOpen: specialDay.timeOpen - specialDay.startOfOpen,
    }
    if (sendValue && sendValue.id) {
      return this.http.put(this.specialDaysUrl + `/${specialDay.id}`, sendValue);
    }
    return this.http.post(this.specialDaysUrl, sendValue);

  }
}
